import { memo } from "react"
import styled from "styled-components"
import Input from "components/EvtKit/input/Input"
import Button from "components/EvtKit/button/Button"
import clsx from "clsx"
import Heading from "components/Typography/Heading"
import Tooltip from "components/Tooltip"

const BlockOrActiveButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const BlockOrActiveInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const ContainerInput = styled.div`
  width: fit-content;
`

interface BlockOrActiveEnterpriseAccountComponentProps {
  title: string
  buttonLabel: string
  inputLabel: string
  inputName: string
  inputValue: string
  disabledButton: boolean
  tooltipMessage: string
  disabledInput?: boolean
  loading?: boolean
  onClick: () => void
  onClickCancel: () => void
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const BlockOrActiveEnterpriseAccountComponent = (props: BlockOrActiveEnterpriseAccountComponentProps) => {
  const {
    title,
    buttonLabel,
    inputLabel,
    inputName,
    inputValue,
    disabledButton,
    tooltipMessage,
    disabledInput,
    loading,
    onClick,
    onClickCancel,
    handleInputChange
  } = props

  const errorMessage = inputValue.length > 150 ? "Limite de 150 caracteres atingido." : ""

  const disabled = disabledButton || inputValue.length === 0 || inputValue.length > 150

  return (
    <Content>
      <BlockOrActiveInputContainer>
        <Heading variant="h6">{title}</Heading>
        <ContainerInput>
          <Input
            name={inputName}
            id="inputValues"
            type="text"
            label={inputLabel}
            onChange={handleInputChange}
            value={inputValue}
            safeBottom
            error={errorMessage}
            limitCharacters={150}
            disabled={disabledInput}
            disabledCharacter={disabledInput}
          />
        </ContainerInput>
      </BlockOrActiveInputContainer>
      <BlockOrActiveButtonContainer>
        <Button type="button" onClick={onClickCancel} label="Cancelar" className={clsx("secondary fill-width")} />
        {disabledButton && (
          <Tooltip text={tooltipMessage} toolTipClassName="position-top">
            <Button
              type="button"
              label={buttonLabel}
              onClick={onClick}
              className={clsx("background-gradient fill-width", { disabled })}
              disabled={disabled}
              loading={loading}
            />
          </Tooltip>
        )}
        {!disabledButton && (
          <Button
            type="button"
            label={buttonLabel}
            onClick={onClick}
            className="background-gradient fill-width"
            disabled={disabled}
            loading={loading}
          />
        )}
      </BlockOrActiveButtonContainer>
    </Content>
  )
}

export default memo(BlockOrActiveEnterpriseAccountComponent)
